import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import SearchSelect from "../../../components/private/searchselect";

const CreateInterview = () => {
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [curriculums, setCurriculums] = useState([]);

useEffect(() => {
  const loadCurriculums = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getCurriculum);

      if (res.success && Array.isArray(res.data)) {
        setCurriculums(res.data);
      }
    } catch (error) {
      console.error("Error al cargar curriculums", error);
    }
  };

  loadCurriculums();
}, [authFetch]);

const curriculumOptions = curriculums.map(c => ({
  value: c.Id,
  label: `${c.first_name} ${c.last_name} | ${c.document}`
}));


  // Estado general del formulario
  const [form, setForm] = useState({
    Id_curriculum: "",
    position_name: "",
    education: "",
    knowledge: "",
    experience: "",
    observation: "",

    perception1: "",
    perception2: "",
    perception3: "",

    motivation1: "",
    motivation2: "",

    experience1: "",
    experience2: "",

    competencies1: "",
    competencies2: "",
    competencies3: "",
    competencies4: "",
    competencies5: "",
    competencies6: "",
    competencies7: "",
    competencies8: "",
    competencies9: "",
    competencies10: "",
    competencies11: "",
    competencies12: "",

    personal1: "",
    personal2: "",
    personal3: "",

    close1: "",
    close2: "",
    close3: "",
    synthesis: "",
    director_appreciation: "",
    reference_verification: "",
  });

  // Manejo de inputs
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  // Enviar al backend
const handleSubmit = async () => {
  try {
    setLoading(true);

    const res = await authFetch(ENDPOINTS.createInterview, {
      method: "POST",
      body: JSON.stringify(form),
    });

    // Validación correcta
    if (res.success) {
      navigate("/session/interview/interview"); 
    } else {
      console.error("Error al guardar entrevista:", res.message);
    }

  } catch (error) {
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};


  // Renderizado por pasos
  const renderStep = () => {
    switch (step) {

      case 1:
        return (
            <>

            {/* Grid general */}
            <div className="row mb-3">

                <div className="col-md-3">
                    <label className="form-label">Fecha actual</label>
                    <p>{new Date().toLocaleDateString()}</p>
                </div>

                <div className="col-md-7">
                <label className="form-label">Colaborador</label>
                <SearchSelect
                  options={curriculumOptions}
                  value={form.Id_curriculum}
                  onChange={(val) =>
                    setForm(prev => ({ ...prev, Id_curriculum: val }))
                  }
                  placeholder="Buscar colaborador..."
                />
                </div>
            </div>

            <div className="mb-4">
                <label className="form-label">Nombre del cargo: </label>
                <input
                type="text"
                name="position_name"
                className="form-control"
                value={form.position_name}
                onChange={handleChange}
                />
            </div>

            <h6 className="mt-4 mb-3">VALORACIÓN DE COMPETENCIAS BÁSICAS DEL CARGO</h6>

            <div className="row">
                {/* EDUCACIÓN */}
                <div className="col-md-2">
                    <label className="form-label">Educación</label>
                    <div>
                        <label className="me-2">
                        <input
                            type="radio"
                            name="education"
                            value="Si"
                            checked={form.education === "Si"}
                            onChange={handleChange}
                        />{" "}
                        Si
                        </label>

                        <label className="ms-3">
                        <input
                            type="radio"
                            name="education"
                            value="No"
                            checked={form.education === "No"}
                            onChange={handleChange}
                        />{" "}
                        No
                        </label>
                    </div>
                </div>

                {/* CONOCIMIENTOS */}
                <div className="col-md-2">
                    <label className="form-label">Conocimientos</label>
                    <div>
                        <label className="me-2">
                        <input
                            type="radio"
                            name="knowledge"
                            value="Si"
                            checked={form.knowledge === "Si"}
                            onChange={handleChange}
                        />{" "}
                        Si
                        </label>

                        <label className="ms-3">
                        <input
                            type="radio"
                            name="knowledge"
                            value="No"
                            checked={form.knowledge === "No"}
                            onChange={handleChange}
                        />{" "}
                        No
                        </label>
                    </div>
                </div>

                {/* EXPERIENCIA */}
                <div className="col-md-2">
                    <label className="form-label">Experiencia</label>
                    <div>
                        <label className="me-2">
                        <input
                            type="radio"
                            name="experience"
                            value="Si"
                            checked={form.experience === "Si"}
                            onChange={handleChange}
                        />{" "}
                        Si
                        </label>

                        <label className="ms-3">
                        <input
                            type="radio"
                            name="experience"
                            value="No"
                            checked={form.experience === "No"}
                            onChange={handleChange}
                        />{" "}
                        No
                        </label>
                    </div>
                </div>

                {/* OBSERVACIONES */}
                <div className="col-md-6">
                    <label className="form-label">Observaciones</label>
                    <textarea
                        name="observation"
                        className="form-control"
                        value={form.observation}
                        onChange={handleChange}
                        rows="3"
                    />
                </div>
            </div>

            <h6 className="mt-4 mb-3">APRECIACIÓN DE PROFESIONAL ENTREVISTADOR</h6>
            <label>Percepción inicial</label>
            <hr></hr>

            <div className="row">
                <div className="mb-3">
                    <label>1. Puntualidad</label>
                    <textarea
                    name="perception1"
                    className="form-control"
                    value={form.perception1}
                    onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label>2. Presentación personal</label>
                    <textarea
                    name="perception2"
                    className="form-control"
                    value={form.perception2}
                    onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label>3.Postura corporal y comunicación verbal</label>
                    <textarea
                    name="perception3"
                    className="form-control"
                    value={form.perception3}
                    onChange={handleChange}
                    />
                </div>
            </div>
            </>
        );

      case 2:
        return (
          <>
            <h6 className="mt-4 mb-3">Motivación</h6>
            <hr></hr>

            <div className="mb-3">
              <label>1.¿Qué sabe de nuestra organización y sobre el cargo?</label>
              <textarea
                name="motivation1"
                className="form-control"
                value={form.motivation1}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>2.¿Por qué está interesado en este empleo?</label>
              <textarea
                name="motivation2"
                className="form-control"
                value={form.motivation2}
                onChange={handleChange}
              />
            </div>

            <h6 className="mt-4 mb-3">Experiencia laboral</h6>
            <hr></hr>

            <div className="mb-3">
              <label>1.¿A que se ha dedicado en la empresa donde ha trabajado y qué funciones desarrollaba dentro de ella?</label>
              <textarea
                name="experience1"
                className="form-control"
                value={form.experience1}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>2.¿Cuál es el trabajo en el que se sintió más a gusto o satisfecho? ¿Por qué?</label>
              <textarea
                name="experience2"
                className="form-control"
                value={form.experience2}
                onChange={handleChange}
              />
            </div>
          </>
        );

      case 3:
        return (
          <>
            <h6 className="mt-4 mb-3">Competencias</h6>
            <hr></hr>

            <div className="mb-3">
              <label>1.¿Cómo describiría sus relaciones interpersonales?</label>
              <textarea
                name="competencies1"
                className="form-control"
                value={form.competencies1}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>2.¿Con qué tipo de personas prefiere trabajar?</label>
              <textarea
                name="competencies2"
                className="form-control"
                value={form.competencies2}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>3.¿Qué piensa de trabajar en equipo?</label>
              <textarea
                name="competencies3"
                className="form-control"
                value={form.competencies3}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>4.¿Cómo describiría su capacidad de comunicación?</label>
              <textarea
                name="competencies4"
                className="form-control"
                value={form.competencies4}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>5.¿Cómo promovería la identidad institucional en su equipo de trabajo?</label>
              <textarea
                name="competencies5"
                className="form-control"
                value={form.competencies5}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>6.¿Qué piensa de la orientación a resultados? podría ejemplificar a partir de su experiencia</label>
              <textarea
                name="competencies6"
                className="form-control"
                value={form.competencies6}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>7.¿Qué piensa de los clientes internos y externos?</label>
              <textarea
                name="competencies7"
                className="form-control"
                value={form.competencies7}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>8.¿Qué haría para satisfacer las necesidades del cliente? Podría dar ejemplos</label>
              <textarea
                name="competencies8"
                className="form-control"
                value={form.competencies8}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>9.¿Qué debe hacer – a su criterio- un buen líder?</label>
              <textarea
                name="competencies9"
                className="form-control"
                value={form.competencies9}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>10.¿Qué oportunidades de mejora o nuevas ideas ha sugerido en anteriores trabajos?</label>
              <textarea
                name="competencies10"
                className="form-control"
                value={form.competencies10}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>11.¿Qué acciones realiza para alcanzar los objetivos planteados?</label>
              <textarea
                name="competencies11"
                className="form-control"
                value={form.competencies11}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>12.¿Qué piensa de las alianzas, redes y trabajos interinstitucionales? ¿Cómo se ha sentido al participar de ellos?</label>
              <textarea
                name="competencies12"
                className="form-control"
                value={form.competencies12}
                onChange={handleChange}
              />
            </div>

       
          </>
        );

      case 4:
        return (
          <>
            <h6 className="mt-4 mb-3">Personal</h6>
            <hr></hr>

              <div className="mb-3">
                <label>1.¿Qué fortalezas y debilidades tiene?</label>
                <textarea
                  name="personal1"
                  className="form-control"
                  value={form.personal1}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label>2.¿Cuáles son las cualidades que tiene para este cargo?</label>
                <textarea
                  name="personal2"
                  className="form-control"
                  value={form.personal2}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label>3.¿Cómo se siente cuando debe enfrentar algo nuevo o diferente?</label>
                <textarea
                  name="personal3"
                  className="form-control"
                  value={form.personal3}
                  onChange={handleChange}
                />
              </div>
          </>
        );

      case 5:
        return (
          <>
            <h6 className="mt-4 mb-3">Cierre</h6>
            <hr></hr>

            <div className="mb-3">
                <label>1.¿Quiere hacer alguna pregunta?</label>
                <textarea
                name="close1"
                className="form-control"
                value={form.close1}
                onChange={handleChange}
                />
            </div>
            <div className="mb-3">
                <label>2.¿Qué debería haberle preguntado y no lo hice?</label>
                <textarea
                name="close2"
                className="form-control"
                value={form.close2}
                onChange={handleChange}
                />
            </div>
            <div className="mb-3">
                <label>3.¿Algo más que quiera aportar y no lo hayamos tratado?</label>
                <textarea
                name="close3"
                className="form-control"
                value={form.close3}
                onChange={handleChange}
                />
            </div>
            <div className="mb-3">
                <label>SINTESIS DE LA ENTREVISTA</label>
                <textarea
                name="synthesis"
                className="form-control"
                value={form.synthesis}
                onChange={handleChange}
                />
            </div>
            <div className="mb-3">
                <label>APRECIACIÓN DEL DIRECTOR/COORDINADOR</label>
                <textarea
                name="director_appreciation"
                className="form-control"
                value={form.director_appreciation}
                onChange={handleChange}
                />
            </div>
            <div className="mb-3">
                <label>VERIFICACIÓN DE REFERENCIAS</label>
                <textarea
                name="reference_verification"
                className="form-control"
                value={form.reference_verification}
                onChange={handleChange}
                />
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h3 className="mb-4 text-center">ENTREVISTA PRESENCIA</h3>

          {renderStep()}

          {/* Navegación */}
          <div className="d-flex justify-content-between mt-4">
            {step > 1 ? (
              <button className="btn btn-secondary" onClick={prevStep}>
                Atrás
              </button>
            ) : (
              <div />
            )}

            {step < 5 ? (
              <button className="btn btn-outline-purple" onClick={nextStep}>
                Siguiente
              </button>
            ) : (
              <button
                className="btn btn-outline-pink"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Guardando..." : "Guardar entrevista"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateInterview;
